

import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SolidInfoIcon',
  props: {
    fill: {
      type: String,
      default: '#A19857'
    },
    stroke: {
      type: String,
      default: 'white'
    }
  }
})

